export default "__VITE_ASSET__0fc04eb6__"